<template>
  <v-container
    fluid
    v-touch="{
      right: () => swipe(),
    }"
    height="100vh"
  >
    <input
      type="file"
      ref="fileInput"
      style="display: none"
      @change="handleFileChange"
      multiple
    />
    <div class="d-flex flex-column justify-space-between" style="height: 100%">
      <div>
        <v-row class="actions align-center" justify="space-between">
          <v-col class="back-arrow" cols="auto">
            <v-btn
              variant="text"
              class="ma-0"
              density="compact"
              icon="mdi-chevron-left"
              :disabled="loading"
              @click="this.$emit('update:modal', false)"
            >
            </v-btn>
          </v-col>
          <v-col cols="auto" v-if="$store.state.isMobile">
            <v-btn
              variant="text"
              icon="mdi-paperclip"
              color="blue-lighten-1"
              @click="openFileDialog"
              :disabled="loading"
            ></v-btn>
            <v-btn
              variant="text"
              icon="mdi-send"
              color="blue-lighten-1"
              @click="send"
              :disabled="loading"
            >
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="align-center ma-0 pa-0">
          <v-list-item-subtitle class="mr-4 mt-3">Кому</v-list-item-subtitle>
          <v-combobox
            v-model="mailsTo"
            variant="plain"
            multiple
            chips
            clearable
            hide-details
            :items="itemsTo"
            @update:modelValue="handleInput"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                v-if="index < 2"
                :key="JSON.stringify(item)"
                close
                @click:close="removeChip(index, 'to')"
              >
                {{ item }}
              </v-chip>
              <span
                v-if="index === 2"
                class="text-grey text-caption align-self-center"
              >
                (+{{ chipsTo.length - 2 }} ещё)
              </span>
            </template>
          </v-combobox>
        </v-row>
        <v-row class="align-center ma-0 pa-0">
          <v-list-item-subtitle class="mr-9 mt-3">От</v-list-item-subtitle>
          <v-select
            hide-details
            v-model="from"
            variant="plain"
            chips
            :items="itemsFrom"
          >
          </v-select>
        </v-row>
        <v-row class="align-center mb-4 ma-0 pa-0">
          <v-list-item-subtitle class="mr-4 mt-4">Тема</v-list-item-subtitle>
          <v-text-field
            hide-details
            v-model="theme"
            variant="plain"
          ></v-text-field>
        </v-row>
        <v-expansion-panels class="mb-4" rounded="xl" v-if="files.length > 0">
          <v-expansion-panel title="Прикрепленные файлы">
            <v-expansion-panel-text>
              <v-row class="files mb-2 d-flex flex-column">
                <v-list
                  :class="$store.state.isMobile ? '' : 'd-flex flex-wrap'"
                >
                  <v-list-item
                    rounded="xl"
                    v-for="(file, index) in files"
                    :key="file"
                    @click="fileDownload(file)"
                  >
                    <v-icon :icon="file.icon"></v-icon>
                    {{ file.name }}
                    <template v-slot:append>
                      <v-icon
                        icon="mdi-close-circle"
                        @click="deleteFile(index)"
                      ></v-icon>
                    </template>
                  </v-list-item>
                </v-list>
              </v-row>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row class="mb-4 ma-0 pa-0">
          <TextEditor v-model:content="content"></TextEditor>
        </v-row>
      </div>
      <div v-if="!$store.state.isMobile">
        <v-file-upload
          v-if="isUpload && !$store.state.isMobile"
          v-model="newFiles"
          density="compact"
          variant="compact"
          rounded="xl"
          multiple
          max-height="20"
          show-size
          clearable
          @change="handleFileChange"
        >
          <template v-slot:item="{ props: itemProps }">
            <v-file-upload-item v-bind="itemProps" lines="one" nav rounded="xl">
              <template v-slot:prepend>
                <v-avatar size="32" rounded></v-avatar>
              </template>

              <template v-slot:clear="{ props: clearProps }">
                <v-btn
                  color="blue-lighten-1"
                  v-bind="clearProps"
                  :disabled="loading"
                ></v-btn>
              </template>
            </v-file-upload-item>
          </template>
        </v-file-upload>
        <v-row class="ma-0 pa-0 align-center">
          <v-btn color="blue-lighten-1 mr-4" @click="send" :disabled="loading"
            >Отправить</v-btn
          >
          <v-btn
            variant="text"
            icon="mdi-paperclip"
            @click="isUpload = !isUpload"
            :disabled="loading"
          ></v-btn>
        </v-row>
      </div>
    </div>
  </v-container>
</template>
<script>
import { VFileUpload } from "vuetify/labs/VFileUpload";
import TextEditor from "./TextEditor.vue";
import axios from "axios";

export default {
  name: "SendModal-component",
  components: {
    VFileUpload,
    TextEditor,
  },
  props: {
    item: Object,
    modelValue: Boolean,
    newMail: String,
    fwd: Boolean,
    index: Number,
  },
  emits: ["update:modal"],
  data() {
    return {
      loading: false,
      newFiles: [],
      isUpload: false,
      theme: "",
      chipsTo: [],
      items: [],
      mailsTo: [],
      itemsFrom: [],
      from: null,
      files: [],
      content: "",
    };
  },
  methods: {
    convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader(); // Создаем объект FileReader

        reader.onload = () => {
          // Удаляем префикс "data:*/*;base64," из результата
          const base64 = reader.result.split(",")[1];
          resolve(base64); // Возвращаем чистый base64
        };

        reader.onerror = (error) => {
          reject(error); // Обрабатываем ошибку
        };

        reader.readAsDataURL(file); // Читаем файл как Data URL
      });
    },
    async send() {
      try {
        this.loading = true;
        let formData = new FormData();
        formData.append(`params`, "sendMail");
        formData.append(`login`, this.$store.state.mailbox[this.index].title);
        formData.append(`password`, this.$store.state.mailbox[this.index].pass);
        formData.append(
          `host`,
          this.$store.state.settings[
            this.$store.state.mailbox[this.index].server
          ].smtp.address
        );
        formData.append(
          `port`,
          this.$store.state.settings[
            this.$store.state.mailbox[this.index].server
          ].smtp.port
        );
        formData.append(`encrypt`, "ssl");
        formData.append(
          `type`,
          this.$store.state.mailbox[this.index].pass ? "password" : "oauth"
        );
        formData.append(`from`, this.from);
        formData.append(`fromName`, this.from);
        for (const index in this.mailsTo) {
          formData.append(`adresses[${index}]`, this.mailsTo[index]);
        }

        formData.append(`subject`, this.theme);
        formData.append(`text`, this.content);
        console.log(this.files);
        for (const fileIndex in this.files) {
          let fileObj = this.files[fileIndex];
          if (this.files[fileIndex] instanceof Blob) {
            const base64 = await this.convertFileToBase64(
              this.files[fileIndex]
            );
            console.log({ base64 });
            fileObj = {
              name: this.files[fileIndex].name, // Имя файла
              base64: base64, // Данные файла в формате base64
            };
            console.log({ fileObj });
            const jsonData = JSON.stringify(fileObj);
            formData.append(`file[${fileIndex}]`, jsonData); // Выводим результат
          } else {
            const jsonData = JSON.stringify(fileObj);
            formData.append(`file[${fileIndex}]`, jsonData);
          }
        }
        //

        //получить все письма по каждой из папки
        const mail = await axios.post("https://email.rcgit.ru/smtp/", formData);
        console.log({ mail });
        this.files = [];
        this.newFiles = [];
        this.content = "";
        this.mailsTo = [];
        this.theme = "";
        this.loading = false;
        this.$emit("update:modal", false);
      } catch (error) {
        console.log({ error });
      }
    },
    openFileDialog() {
      this.$refs.fileInput.click();
    },
    // Метод для обработки выбора файла
    handleFileChange(event) {
      const selectedFiles = event.target.files;
      console.log({ selectedFiles });
      if (selectedFiles) {
        this.files.push(...Array.from(selectedFiles));

        // Преобразуем FileList в массив и сохраняем
      }
    },
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    handleInput(value) {
      console.log("Введенное значение:", value);
    },
    removeChip(index, type) {
      if (type == "To") {
        this.chipsTo.splice(index, 1);
      } else {
        this.chipsFrom.splice(index, 1);
      }
    },
    pause(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    swipe() {
      this.$emit("update:modal", false);
    },
  },
  created() {
    if (!this.newMail) {
      console.log(this.item);
      this.content = this.fwd
        ? `
      <br/>
      -------- Пересылаемое сообщение --------<br/>
 ${this.item.dateTitle}, ${this.item.timeTitle}, "${this.item.fromName}" <${this.item.from}>:<br/>
Кому: ${this.item.to};<br/>
Тема: ${this.item.subject};<br/>
      ${this.item.body}`
        : `
      <br/>
      ----------------<br/>
      Кому: ${this.item.to};<br/>
      Тема: ${this.item.subject};<br/>
      ${this.item.dateTitle}, ${this.item.timeTitle}, "${this.item.fromName}" <${this.item.from}>:<br/>
      ${this.item.body}`;
      this.theme = this.fwd
        ? `Fwd: ${this.item.subject}`
        : `Re: ${this.item.subject}`;
      this.files = this.item.files;
      this.mailsTo = this.fwd ? [] : [this.item.from];
    }
    for (const box of this.$store.state.mailbox) {
      this.itemsFrom.push(box.title);
    }
    this.from = this.$store.state.mailbox[this.index].title;
  },
};
</script>
<style scoped>
.displaynone {
  display: none;
}
</style>
